import * as React from 'react';

import { Link } from '@coursera/cds-core';

import ProgramMembershipCredits from 'bundles/internal-enterprise/components/ProgramMembershipCredits';
import ProgramMembershipLimit from 'bundles/internal-enterprise/components/ProgramMembershipLimit';

export default {
  partitionSize: 50,

  columns: {
    pendingInvitations: [
      {
        key: 'programName',
        name: 'Name',
        render: (name: $TSFixMe, program: $TSFixMe) => (
          <div>
            <span>
              <Link
                target="_blank"
                rel="noopener noreferrer"
                href={`https://www.coursera.org/programs/${program.programSlug}`}
              >
                {name}
              </Link>
            </span>
            <br />
            <span>
              <strong>Program Slug:</strong> {program.programSlug}
            </span>
            <br />
            <span>
              <strong>Program ID:</strong> {program.programId}
            </span>
            <br />
            <span>
              <Link
                target="_blank"
                rel="noopener noreferrer"
                href={`https://www.coursera.org/o/${program.organizationSlug}/admin/programs/${program.programSlug}/main`}
              >
                Admin Page
              </Link>
            </span>
          </div>
        ),
      },
      {
        key: 'typeName',
        name: 'Type of Program',
      },
      {
        key: 'contractId',
        name: 'Enrollment Limit',
        render: (contractId: $TSFixMe) => <ProgramMembershipLimit contractId={contractId} />,
      },
    ],
    programMemberships: [
      {
        key: 'programName',
        name: 'Name',
        render: (name: $TSFixMe, program: $TSFixMe) => (
          <div>
            <span>
              <Link
                target="_blank"
                rel="noopener noreferrer"
                href={`https://www.coursera.org/programs/${program.programSlug}`}
              >
                {name}
              </Link>
            </span>
            <br />
            <span>
              <strong>Program Slug:</strong> {program.programSlug}
            </span>
            <br />
            <span>
              <strong>Program ID:</strong> {program.programId}
            </span>
            <br />
            <span>
              <Link
                target="_blank"
                rel="noopener noreferrer"
                href={`https://www.coursera.org/o/${program.organizationSlug}/admin/programs/${program.programSlug}/main`}
              >
                Admin Page
              </Link>
            </span>
          </div>
        ),
      },
      {
        key: 'role',
        name: 'Role',
      },
      {
        key: 'typeName',
        name: 'Type of Program',
      },
      {
        key: 'id',
        name: 'Credit Limit?',
        render: (id: $TSFixMe) => <ProgramMembershipCredits programMembershipId={id} />,
      },
      {
        key: 'createdAt',
        name: 'Join Date',
        type: 'timestamp',
      },
    ],
  },
};
